export const AUTH_ATTEMPT = 'AUTH_ATTEMPT';
export const PATH_AUTOLOGIN = '/autologin';
export const UNAUTHORIZED = 'unauthorized';
export const REDIRECT = 'redirect_url';
export const LOGOUT_MARKER = 'logout_marker';
export const MY_WORLD_REDIRECT_URL = 'my_world_redirect_url';
export const SKIP_AMBASSADOR_AD = 'skip_ambassador_ad';

export const ACTIVE = 'active';
export const INCOMPLETE = 'incomplete';
export const CONFIRMED = 'confirmed';
export const FAILED = 'failed';

export const ECREDITS_IN = 'ecredits-in';
export const ECREDITS_OUT = 'ecredits-out';
export const EACTIVITY_IN = 'eactivity-in';
export const EACTIVITY_OUT = 'eactivity-out';
export const CASHBACK_IN = 'cashback-in';
export const ETHEREUM_IN = 'ethereum-in';
export const ETHEREUM_OUT = 'ethereum-out';
export const VAULT_IN = 'vault-in';
export const VAULT_OUT = 'vault-out';
export const TOKEN_IN = 'token-in';
export const TOKEN_OUT = 'token-out';

export const ALLOW_ALL_FEATURES = 'allow_all_features';

export const COMPANY_NAME = 'The People´s SCE';

export const DEFAULT_FRACTION_DIGITS = 2;
export const DEFAULT_ETH_FRACTION_DIGITS = 6;
export const MAX_FRACTION_DIGITS = 8;

export const BLOCKTRADE = 'Blocktrade';

export const ACTIVE_SETTINGS_TAB = 'active_settings_tab';
export const BACK_SETTINGS_REDIRECT = 'back_settings_redirect';
export const SIDEBAR_CLOSED_STATE = 'sidebar_closed_state';

export const ENTERPRISE = 'enterprise';
export const PREMIUMWHITE = 'subscription_premium_white';
export const PREMIUMBLUE = 'subscription_premium_blue';
export const BASICGRAY = 'subscription_basic_gray';
export const BASICBLUE = 'subscription_basic';
export const BASICWHITE = 'subscription_basic_white';
export const AMBASSADOR = 'ambassador';
export const SCE_MEMBERSHIP = 'sce-membership';
export const EMPTY = 'empty';
export const REGULAR = 'regular';
export const PERSONAL_GOLD = 'personal-gold';
export const PERSONAL_PLATINUM = 'personal-platinum';
export const CONSUMER = 'consumer';
export const BUSINESS = 'business';

export const INVITATIONS = 'invitations';
export const BUYECS = 'buyecs';
export const PRICETAGS = 'pricetags';
export const STORES = 'stores';

export const TOTAL_BUSINESS_PROFILES = 'invitationLinkBusinessProfiles';
export const TOTAL_CONSUMER_PROFILES = 'invitationLinkConsumerProfiles';

export const DEFAULT_GRAPH_DAYS = 8;

export const IMAGE_JPEG = 'image/jpeg';
export const IMAGE_PNG = 'image/png';
export const APPLICATION_PDF = 'application/pdf';

export const UNACCEPTED_INVITATION = 'unaccepted_invitation';

export const THEME_LANG = 'theme_lang';

export const GOLD = 'Gold';
export const PLATINUM = 'Platinum';

export const MONTH_IN_MILISECONDS = 2629800000;

export const DAY_IN_MILISECONDS = 86400000;

export const REDEEM_VOUCHER = 'redeem_voucher';

export const SUBSCRIPTION_DEFINITION = 'subscription_definition';

export const COMPANY = 'COMPANY';

export const DISMISSED_BANNER_KEY = 'dismissedSubscriptionBanner';

export const CURRENT_DEALS = 'current_deals';
export const EXPIRED_DEALS = 'expired_deals';
export const EDIT_DEAL = 'edit_deal';
export const CREATE_DEAL = 'create_deal';
export const ALL_STORES = 'all_stores';
export const INVALID_DATE = 'Invalid Date';

export const EDIT_MULTI_PAYMENT = 'edit_multi_payment';

export const DEFAULT_PAYMENT_TEMPLATE_TRANSACTIONS = 3;

export const DEFAULT_TOKEN_DECIMALS = 18;
